import { isInitialized } from '@braze/web-sdk';

/** True when PageContainer has called Braze `initialize()` for this session. */
export const isBrazeReady = () => isInitialized();
